import { useTenantDetailsContext } from '../TenantDetailsContext';

export function useAiInsightsEnabled(): boolean {
  const { applicationConfiguration } = useTenantDetailsContext();
  // The configuration flag is for if AI insights are disabled, so we need to negate it.
  // Also, if the configuration is not present, we should default to enabled.
  return !applicationConfiguration?.disableAiInsights;
}
